import { useScene } from '../../../hooks';
import { useEditor } from '../../../hooks/useEditor';
import { IconButton } from '../../generic/IconButton';
import { Modal } from '../../generic/modal/Modal';
import { Versions } from '../Versions';

export const TopbarButtons = () => {
  const scene = useScene();
  const { UI, setUI } = useEditor();
  const dialogOpen = UI.isVersionModalOpen;
  const setDialogOpen = (value: boolean) =>
    setUI((UI) => ({ ...UI, isVersionModalOpen: value }));

  return (
    <>
      <div id="versions-icon">
        <Modal
          open={dialogOpen}
          setOpen={setDialogOpen}
          triggerElement={
            <IconButton handleClick={() => setDialogOpen(true)}>
              <i className="icon-versions" />
            </IconButton>
          }
          title="Versions"
          description="Manage your theme versions"
        >
          <Versions setDialogOpen={setDialogOpen} />
        </Modal>
      </div>

      <div id="save-icon">
        <IconButton handleClick={() => scene.saveThemeVersion()}>
          <i className="icon-save" />
        </IconButton>
      </div>
    </>
  );
};
